<div class="row">
    <div class="col-1">
      <app-back-button></app-back-button>
    </div>
    <div class="col">
      <h2 class="h2-responsive text-center">New Label</h2>
    </div>
  </div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
      <div class="view gradient-card-header primary-gradient white-text">
          <h3 class='h3-responsive text-center text-truncate'>{{label.label || "Untitled"}}</h3>
      </div>
      <form class="card-body">
        <div class="form-group">
            <label for="label">Label:</label>
            <input class="form-control" type="text" id="label" name="label" [(ngModel)]="label.label" />
          </div>
        <!--<div class="form-group">
              <label for="displayOrder">Display Order:</label>
          <input class="form-control" type="number" id="displayOrder" name="displayOrder" [(ngModel)]="ctrl.label.display_order" />
        </div>-->
        <div class="form-group">
          <input class="form-control" type="checkbox" id="skip-scoring" name="skip-scoring" [checked]="label.skipScoring" [(ngModel)]="label.skipScoring" />
          <label for="skip-scoring">Skip Scoring: (N/A questions)</label>
        </div>
      </form>
      <div class="row">
        <div class="col">
          <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
          <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
        </div>
      </div>
      
      <!--<pre>
        {{label|json}}
      </pre>-->
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/label-new/label-new.component.html